/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetCountContactsEmailTransactionsResponseData,
  GetCountContactsEmailTransactionsResponseDataFromJSON,
  GetCountContactsEmailTransactionsResponseDataFromJSONTyped,
  GetCountContactsEmailTransactionsResponseDataToJSON
} from './GetCountContactsEmailTransactionsResponseData'

/**
 *
 * @export
 * @interface GetChatSummariesCountResponse
 */
export interface GetChatSummariesCountResponse {
  /**
   *
   * @type {number}
   * @memberof GetChatSummariesCountResponse
   */
  status?: number
  /**
   *
   * @type {GetCountContactsEmailTransactionsResponseData}
   * @memberof GetChatSummariesCountResponse
   */
  data?: GetCountContactsEmailTransactionsResponseData
}

export function GetChatSummariesCountResponseFromJSON(json: any): GetChatSummariesCountResponse {
  return GetChatSummariesCountResponseFromJSONTyped(json, false)
}

export function GetChatSummariesCountResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetChatSummariesCountResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetCountContactsEmailTransactionsResponseDataFromJSON(json['data'])
  }
}

export function GetChatSummariesCountResponseToJSON(value?: GetChatSummariesCountResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetCountContactsEmailTransactionsResponseDataToJSON(value.data)
  }
}
